import * as React from 'react'

import {
  Button,
  Modal,
  Space,
  TextBody,
  TextHeading,
  useModal,
} from '@ally/metronome-ui'

import { ImageWrapper } from '../Components/Shared'
import agreementNumber from '../assets/images/agreement-number.jpg'

const headingRef = React.createRef<HTMLHeadingElement>()

const ModalContent: React.FC = () => {
  const altText =
    'You can locate your account number, called your Agreement Number, under Account Information on your most recent billing statement.'

  return (
    <>
      <Space mb="md">
        <TextHeading
          data-testid="account-number-modal-header"
          ref={headingRef}
          tabIndex={-1}
          tag="h1"
          size="md"
        >
          Where to find your account number
        </TextHeading>
      </Space>

      <Space mb="lg">
        <TextBody tag="p" size="md">
          Your account number is listed on your most recent billing statement as
          “Agreement Number”.
        </TextBody>
      </Space>

      <Space mb="md">
        <ImageWrapper>
          <img alt={altText} src={agreementNumber} />
        </ImageWrapper>
      </Space>
    </>
  )
}

const ModalTriggerComponent: React.FC<{ allytmln: string }> = ({
  allytmln,
}) => {
  const { showModal } = useModal()

  return (
    <Button
      withAllyTM={allytmln}
      data-testid="account-number-modal-trigger"
      onClick={showModal}
      text="Where to find your account number"
      variant="link"
    />
  )
}

export const FindAccountNumberModal: React.FC<{ allytmln?: string }> = ({
  allytmln = 'whereToFindYourAccountNumber',
}) => (
  <Modal
    content={<ModalContent />}
    ref={headingRef}
    trigger={<ModalTriggerComponent allytmln={allytmln} />}
  />
)
